exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 720px) {\n  .content {\n    margin: 0;\n    padding: 0;\n    display: inline-block;\n    text-align: justify; }\n  .sidebar {\n    width: 33.333%;\n    margin: 0;\n    padding: 0;\n    float: right;\n    display: inline-block; } }\n\n.sidebox {\n  -webkit-box-shadow: 2px 2px 5px #333;\n          box-shadow: 2px 2px 5px #333;\n  margin-left: 25px;\n  margin-bottom: 25px; }\n\n.sidebox .title {\n    text-align: center;\n    background-color: #ad0e68;\n    color: white;\n    padding: 10px; }\n\n.sidebox img {\n    width: 25%; }\n\n.sidebox .sidebar-content {\n    display: inline-block;\n    padding: 10px;\n    width: 100%; }\n\n.sidebox .sidebar-content a {\n      float: right; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/leonhard/Projekte/braungardt/angular/src/app/page/page.component.scss
// module id = ../../../../../src/app/page/page.component.scss
// module chunks = main